import React from "react";
const AlignCenterIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "15",
    height: "18",
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.5 10H8V8H10.5C11.3 8 12 7.3 12 6.5V3.5C12 2.7 11.3 2 10.5 2H8V0H7V2H4.5C3.7 2 3 2.7 3 3.5V6.5C3 7.3 3.7 8 4.5 8H7V10H1.5C0.7 10 0 10.7 0 11.5V14.5C0 15.3 0.7 16 1.5 16H7V18H8V16H13.5C14.3 16 15 15.3 15 14.5V11.5C15 10.7 14.3 10 13.5 10ZM4 6.5V3.5C4 3.2 4.2 3 4.5 3H10.5C10.8 3 11 3.2 11 3.5V6.5C11 6.8 10.8 7 10.5 7H4.5C4.2 7 4 6.8 4 6.5ZM14 14.5C14 14.8 13.8 15 13.5 15H1.5C1.2 15 1 14.8 1 14.5V11.5C1 11.2 1.2 11 1.5 11H13.5C13.8 11 14 11.2 14 11.5V14.5Z",
      fill: "currentColor"
    }
  )
);
var AlignCenterIcon_default = AlignCenterIcon;
export {
  AlignCenterIcon_default as default
};
//# sourceMappingURL=AlignCenterIcon.js.map
